import { Injectable } from '@angular/core';
import { Service } from '../Service.js';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '@app/helpers/app.settings';
import { AppHelper } from '@app/helpers/app.helper';

@Injectable()
export class RecommendationService extends Service {
  constructor(private _http: HttpClient) {
    super();
  }

  getRecommendations(filter) {
    return this._http
      .get(
        this.API_ENDPOINT +
          'recommendation?' +
          AppHelper.serializeObj(filter),
        this.APP_REQUEST_OPTIONS
      )
      .toPromise()
      .catch((error) => {
        console.log(error);
        console.log(error._body);
      });
  }
}
